<template>
    <v-card>
        <v-card-title>
            <h3>Subscriptions</h3>
            <v-spacer />
            <v-tooltip v-if="tier && !hasActiveSubscription" bottom>
                <template v-slot:activator="{ on }">
                    <v-btn
                        v-on="on"
                        color="primary"
                        @click="createSubscriptionForm()"
                        :loading="createLoading"
                        fab
                        dark
                    >
                        <v-icon dark>mdi-plus</v-icon>
                    </v-btn>
                </template>
                <span>New Subscription</span>
            </v-tooltip>
        </v-card-title>
        <v-card-text>
            <subscriptions-grid
                :client_id.sync="
                    this.$store.getters.userForPortalAccess.client.id
                "
                :reload.sync="reloadVar"
                @show-subscription="showSubscription"
                @subscriptions-loaded="getSubscriptionStatus"
            />
        </v-card-text>
        <v-dialog
            @input="toggleSubscriptionDialog"
            v-model="showSubscriptionDialog"
            max-width="800"
        >
            <subscription-dialog
                @close="closeSubscriptionDialog"
                :subscription.sync="subscription"
            />
        </v-dialog>
    </v-card>
</template>
<script>
import SubscriptionsGrid from '@/views/user-dashboard/subscriptions/SubscriptionsGrid.vue'
import SubscriptionDialog from '@/views/user-dashboard/subscriptions/SubscriptionDialog.vue'

export default {
    name: 'subscriptions',
    components: {
        SubscriptionDialog,
        SubscriptionsGrid,
    },
    data() {
        return {
            creationSuccess: this.$route.query.success,
            reloadVar: 0,
            showSubscriptionDialog: false,
            subscription: null,
            createLoading: false,
            tier: this.$store.getters.userForPortalAccess.client.stripe_plan,
            hasActiveSubscription: false,
        }
    },
    mounted() {
        // If subscription has success status
        if (typeof this.creationSuccess !== 'undefined') {
            const message = {
                type: 'success',
                title: 'Success',
                text: 'Subscription created successfully.',
            }

            if (this.creationSuccess == '0') {
                message.type = 'error'
                message.title = 'Error'
                message.text = 'Something went wrong.'
            }

            this.$store.dispatch('responseMessage', {
                type: message.type,
                title: message.title,
                text: message.text,
            })
        }
    },
    methods: {
        reloadGrid: function() {
            this.reloadVar++
        },
        createSubscriptionForm: function() {
            this.createLoading = true

            this.$apollo
                .mutate({
                    // Query
                    mutation: require('@/graphql/subscription/createSubscription.gql'),
                    variables: {
                        user_id: this.$store.getters.userForPortalAccess.id,
                    },
                })
                .then(({ data }) => {
                    // Redirects to subscription checkout
                    window.location.href = data.createSubscription.url
                })
                .finally(() => {
                    this.createLoading = false
                })
        },
        showSubscription: function(subscription) {
            this.showSubscriptionDialog = true

            this.$apollo
                .mutate({
                    // Query
                    mutation: require('@/graphql/subscription/subscription.gql'),
                    variables: { id: subscription.id },
                })
                .then(({ data }) => {
                    this.subscription = data.subscription
                })
        },
        toggleSubscriptionDialog: function(showSubscriptionDialog) {
            if (!showSubscriptionDialog) {
                this.subscription = null
            }
        },
        closeSubscriptionDialog: function() {
            this.showSubscriptionDialog = false
            this.subscription = null
        },
        getSubscriptionStatus(subscriptions) {
            this.hasActiveSubscription = subscriptions?.some(
                subscription => !subscription.ended
            )
        },
    },
}
</script>
